module.exports = __webpack_public_path__ + "static/media/squirrel.b2687766.svg";